import { UserRoleEnum as n, PrivilegeEnum as e } from "./schemas.js";
const d = (i) => i.privileges.includes(e.ReadAdmin), o = (i) => i.privileges.includes(e.WriteAdmin), m = (i) => i.privileges.includes(e.SplitTrafficSourceBySsp), c = [n.Admin, n.AdAdmin], t = (i) => i.some((s) => c.includes(s));
export {
  c as IMPERSONATION_ROLES,
  t as canImpersonate,
  m as canSplitTrafficSourceBySsp,
  d as hasAdminRead,
  o as hasAdminWrite
};
//# sourceMappingURL=privileges.js.map
